<h3>DE CIFRIS HISTORIAE</h3>
<p>
	Il nuovo gruppo tematico De Cifris Historiae dell'iniziativa nazionale
	De Componendis Cifris, raccoglie i membri interessati agli aspetti
	storici della crittografia, le storie della crittografia sono
	affascinanti e allo stesso tempo dettagliate nei loro contenuti.

<h4>EVENTI</h4>
<p>Gli eventi proposti verranno mostrati in questa sezione.</p>

<h4>SEMINARI RECENTI</h4>
<p>I seminari proposti verranno mostrati in questa sezione.</p>
<ul>

</ul>

<h4>PROSSIMI SEMINARI</h4>
<p>I seminari proposti verranno mostrati in questa sezione.</p>
<!-- <ul>
				<li> 
					<b>2 Novembre 2021</b>
					<ul>
						<li>
							<b>Paolo Santini</b> <br>
							<i>" Recent advances in code-based encryption and digital signatures"</i><br>
							<br>
						</li>
					</ul>
				</li>
				<li>
					<b>7 Dicembre 2021</b>
					<ul>
						<li>
							<b>Cecilia Boschini</b> <br>
							<i>"Leakages in the efficient verification of post-quantum digital signatures"</i><br>
							<br>
						</li>
					</ul>
				</li>
			</ul> -->
<h4>SEMINARI PASSATI</h4>
<p>I seminari proposti verranno mostrati in questa sezione.</p>
<ul>
	<li>
		<b>6 Novembre 2020</b>
		<ul>
			<li>
				<b>Marco Moraglio</b> <br>
				<i>"Scrivere per nascondere, leggere per scoprire.
					La crittografia nella Roma antica"</i><br>
				<a href="../../../../assets/attivita/seminariLocali/deCifris
							Historiae/Moraglio_Locandina.pdf">Locandina</a> --
				<a href="../../../../assets/attivita/seminariLocali/deCifris
							Historiae/MORAGLIO-slide.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=v3jGrVNa4H8&authuser=
							1">Video</a>
				<br>
			</li>
		</ul>
	</li>
</ul>